import { useTranslation } from "react-i18next";
import { BaseLogo } from "../../../core/models/entities/BaseLogo";
import { enviroment } from "../../../enviroment";
import { Dot } from "../Dot";
import { TypographyR } from "../Typographies/SectionHeaderTypography";
import { StorageRefreshButton } from "./StorageRefreshButton";
import { StorageUpdatedAt } from "./StorageUpdatedAt";

interface Props {
  logo: BaseLogo;
}

// The "In storage" lines of the logo detail: dot, count, the "refresh stock
// now" button and the "stock updated" caption. Shown when there is stock -
// and, with the manual refresh on (storageManualRefreshEnabled +
// storageFreshnessEnabled), ALSO at 0: a cached 0 that is stale is exactly
// the count that costs an order, so the customer must be able to refresh it
// from NAV right there. With the flags off a 0 renders nothing, as before.
export function LogoDetailStorage({ logo }: Props) {
  const { t } = useTranslation();
  const storage = Math.max(0, logo.inStorage ?? 0);
  const manualRefresh =
    enviroment.storageManualRefreshEnabled &&
    enviroment.storageFreshnessEnabled;
  if (storage <= 0 && !manualRefresh) return null;
  return (
    <>
      <TypographyR className="flex items-center gap-x-1">
        <b>{t("logoList.inStorage")}</b>
        <div className="flex items-center">
          <Dot className={storage > 0 ? "!bg-status-success" : ""} />
          {storage}
          <StorageRefreshButton logo={logo} />
        </div>
      </TypographyR>
      <StorageUpdatedAt storageUpdatedAtUtc={logo.storageUpdatedAtUtc} />
    </>
  );
}
